// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"13":"edit-service","56":"Reports","421":"Notifications","486":"Notes","707":"Courses","751":"locations-add","884":"admin"}[chunkId] + "." + {"13":"3267a5cf","56":"906a0c27","421":"408ee6e3","486":"b4a679c2","707":"cbf96236","751":"e10d2f07","884":"914b6e5a"}[chunkId] + ".css";
};